'use strict';

/*global Container */
/*global Translator */
/*global Configurations*/
/*global Router */
/*global K2Modal */
/*global K2Confirm */
/*global Notifications */
/*global Stopwatches*/
/*global Project */
/*global ProjectTimesheet */
/*global ProjectStagePlannedOperation*/
/*global ProjectStagePlannedOperationBulk*/
/*global ProjectJobQueue*/
/*global K2TimerContainer*/
/*global K2AboutApp*/

var services = new Container();
$(document).ready(function () {
  services.set('translator', new Translator('k2_translations'));
  services.set('configurations', new Configurations('k2_configurations'));
  services.set('router', new Router('k2_paths'));
  services.set('modal', new K2Modal('k2-modal'));
  services.set('modal-lookup', new K2Modal('k2-modal-lookup'));
  services.set('confirm', new K2Confirm('k2-confirm'));
  services.set('notifications', new Notifications());
  services.set('about-app', new K2AboutApp());
  services.set('stopwatches', new Stopwatches('stopwatches'));
  services.set('project', new Project());
  services.set('project-timesheet', new ProjectTimesheet());
  services.set('project-stage-planned-operation', new ProjectStagePlannedOperation());
  services.set('project-stage-planned-operation-bulk', new ProjectStagePlannedOperationBulk());
  services.set('project-job-queue', new ProjectJobQueue());
  services.set('timers', new K2TimerContainer());
});
